export default "/assets/images/graph-pet-dander-sm.847aeffe0683fa4a.png";